import store from '../store';

export default {
    data() {
        return {
            addingToCart: false,
        };
    },

    computed: {
        comboUrl() {
            return route('combos.show', this.combo.slug);
        },

        hasAnyOption() {
            return this.combo.options_count > 0;
        },

        hasNoOption() {
            return ! this.hasAnyOption;
        },

        hasBaseImage() {
            return this.combo.base_image.length !== 0;
        },

        baseImage() {
            if (this.hasBaseImage) {
                return this.combo.base_image.path;
            }

            return `${window.FleetCart.baseUrl}/themes/storefront/public/images/image-placeholder.png`;
        },

        inWishlist() {
            return store.inWishlist(this.combo.id);
        },

        inCompareList() {
            return store.inCompareList(this.combo.id);
        },
    },

    methods: {
        syncWishlist() {
            store.syncWishlist(this.combo.id);
        },

        syncCompareList() {
            store.syncCompareList(this.combo.id);
        },

        addToCart() {
            this.addingToCart = true;

            $.ajax({
                method: 'POST',
                url: route('cart.items.store', { combo_id: this.combo.id, qty: 1 }),
            }).then((cart) => {
                store.updateCart(cart);

                if (document.location.href !== route('cart.index').url()) {
                    $('.header-cart').trigger('click');
                }
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.addingToCart = false;
            });
        },
    },
};
